<template>
	<div>
		<!-- right sidebar start -->
		<div class="">
			<aside class="sidebar-right bottom-bar" :class="{'show':showbar}">
				<div class="expand-btn d-none-sm">
					<img @click="showSidebar()" src="../../assets/icon/arrow-left.svg" alt="expand" class="toggle-expand">
				</div>
				<div class="sidebar-right-inner">

					<!-- /. sidebar-top start -->
					<div class="sidebar-top">
						<!-- desktop search start -->
						<div class="sidebar-search  d-none-sm">
							<label>Search Image</label>
							<input type="text" v-model="sidebarSarch" placeholder="Search..." />
						</div>
						<!-- desktop search end  -->

						<div class="sidebar-add d-none-lg d-block-sm" @click="addPageModal()" id="v-step-0">
							<img src="../../assets/icon/plus-white.svg" alt="plus btn" />
							Add Page
						</div>
						<div class="sidebar-btn-group">
							<ul>
								<li>
									<div class="mbl-sidebar-search d-none-lg d-block-sm" :class="{'expandSearchBar':expandSearchBar}" v-click-outside="closeExpandSearch">
										<button><img src="../../assets/icon/search-icon.svg" alt="search-icon"></button>
										<input type="text" v-model="sidebarSarch" placeholder="Search Image" @click="mblSearchClk"/>
									</div>
								</li>
								<li>
									<button class="search-btn">
										<svg width="22px" height="22px">
										  <g id="image" transform="translate(1 1)">
										    <path d="M1.999 0L18.001 0C19.105 0 20 0.894983 20 1.999L20 18.001C20 19.105 19.105 20 18.001 20L1.999 20C0.894983 20 0 19.105 0 18.001L0 1.999C0 0.894983 0.894983 0 1.999 0Z" id="Rectangle" fill="none" stroke="#214163" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
										    <path d="M1.66667 3.33333C2.58714 3.33333 3.33333 2.58714 3.33333 1.66667C3.33333 0.746192 2.58714 0 1.66667 0C0.746192 0 0 0.746192 0 1.66667C0 2.58714 0.746192 3.33333 1.66667 3.33333Z" transform="translate(4.445313 4.444458)" id="Oval" fill="none" stroke="#214163" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
										    <path d="M17.7778 5.55556L12.2222 0L0 12.2222" transform="translate(2.222656 7.777771)" id="Path" fill="none" stroke="#214163" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
										  </g>
										</svg>
									</button>
								</li>
								<li>
									<button class="search-btn gif">GIF</button>
								</li>
								<li>
									<button class="search-btn">
										<svg width="20px" height="20px" viewBox="0 0 20 20">
										  <g id="upload" transform="translate(1 1)">
										    <path d="M18 0L18 4C18 5.10457 17.1046 6 16 6L2 6C0.89543 6 0 5.10457 0 4L0 0" transform="translate(0 12)" id="Path" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
										    <path d="M10 5L5 0L0 5" transform="translate(4 0)" id="Path" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
										    <path d="M0.5 0L0.5 12" transform="translate(8.5 0)" id="Path" fill="none" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
										  </g>
										</svg>
									</button>
								</li>
								<li>
									<button class="search-btn">
										<svg width="23px" height="21px">
										  <path d="M19.2913 1.61183C18.2598 0.579817 16.8604 -8.88178e-16 15.4013 0C13.9422 4.44089e-16 12.5428 0.579817 11.5113 1.61183L10.4513 2.67183L9.39129 1.61183C7.2429 -0.536562 3.75968 -0.536562 1.61129 1.61183C-0.537097 3.76021 -0.537097 7.24344 1.61129 9.39182L2.67129 10.4518L10.4513 18.2318L18.2313 10.4518L19.2913 9.39182C20.3233 8.3603 20.9031 6.96096 20.9031 5.50183C20.9031 4.04269 20.3233 2.64335 19.2913 1.61183Z" transform="translate(1 1)" id="Path" fill="none" stroke="#214163" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
										</svg>
									</button>
								</li>
								<li >
					                <base-dropdown class="dropdown-sm">
					                    <div class="dropdown-sm-icon" slot="title">
											<button class="search-btn dropdown-sm">
												<svg width="22px" height="5px">
												  <g id="more-horizontal" transform="translate(1 1)">
												    <path d="M1.25 2.5C1.94036 2.5 2.5 1.94036 2.5 1.25C2.5 0.559644 1.94036 0 1.25 0C0.559644 0 0 0.559644 0 1.25C0 1.94036 0.559644 2.5 1.25 2.5Z" transform="translate(8.75 0)" id="Oval" fill="none" stroke="#214163" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
												    <path d="M1.25 2.5C1.94036 2.5 2.5 1.94036 2.5 1.25C2.5 0.559644 1.94036 0 1.25 0C0.559644 0 0 0.559644 0 1.25C0 1.94036 0.559644 2.5 1.25 2.5Z" transform="translate(17.5 0)" id="Oval" fill="none" stroke="#214163" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
												    <path d="M1.25 2.5C1.94036 2.5 2.5 1.94036 2.5 1.25C2.5 0.559644 1.94036 0 1.25 0C0.559644 0 0 0.559644 0 1.25C0 1.94036 0.559644 2.5 1.25 2.5Z" id="Oval" fill="none" stroke="#214163" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
												  </g>
												</svg>
											</button>
					                    </div>

					                    <template>
					                        <router-link to="/recently-used" class="dropdown-item ">
					                            Recently used
					                        </router-link>
					                        <router-link to="/image-collections" class="dropdown-item">
					                            Image Collections
					                        </router-link>
					                        <router-link to="/themes" class="dropdown-item ">
					                           Themes
					                        </router-link>
					                    </template>
					                </base-dropdown>
								</li>
							</ul>
						</div>
					</div>
					<!-- /. sidebar-top end -->

					<!-- sidebar-collection start -->
					<div class="sidebar-collection">
						<div class="collection-btn" v-if="showCollBtn">
							<button @click="backToColl">
								<svg width="10px" height="18px">
								  <path d="M8 16L0 8L8 0" transform="translate(1 1)" id="Path" fill="none" stroke="#214163" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								</svg>
							</button>
							<button @click="showCollModal()">
								<svg width="26px" height="26px">
								  <g id="settings" transform="translate(0.75 0.75)">
								    <path d="M3.27273 6.54545C5.0802 6.54545 6.54545 5.0802 6.54545 3.27273C6.54545 1.46525 5.0802 0 3.27273 0C1.46525 0 0 1.46525 0 3.27273C0 5.0802 1.46525 6.54545 3.27273 6.54545Z" transform="translate(8.726563 8.727264)" id="Oval" fill="none" stroke="#214163" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								    <path d="M20.0727 15.2727C19.7756 15.9459 19.9182 16.7322 20.4327 17.2582L20.4982 17.3236C20.9079 17.7329 21.1381 18.2882 21.1381 18.8673C21.1381 19.4463 20.9079 20.0017 20.4982 20.4109C20.0889 20.8206 19.5336 21.0508 18.9545 21.0508C18.3755 21.0508 17.8201 20.8206 17.4109 20.4109L17.3455 20.3455C16.8194 19.8309 16.0332 19.6884 15.36 19.9855C14.7006 20.2681 14.272 20.9153 14.2691 21.6327L14.2691 21.8182C14.2691 23.0232 13.2923 24 12.0873 24C10.8823 24 9.90545 23.0232 9.90545 21.8182L9.90545 21.72C9.88817 20.9811 9.42095 20.3279 8.72727 20.0727C8.05408 19.7756 7.26784 19.9182 6.74182 20.4327L6.67636 20.4982C6.26712 20.9079 5.7118 21.1381 5.13273 21.1381C4.55365 21.1381 3.99833 20.9079 3.58909 20.4982C3.1794 20.0889 2.94919 19.5336 2.94919 18.9545C2.94919 18.3755 3.1794 17.8201 3.58909 17.4109L3.65455 17.3455C4.16909 16.8194 4.31165 16.0332 4.01455 15.36C3.73193 14.7006 3.0847 14.272 2.36727 14.2691L2.18182 14.2691C0.976833 14.2691 2.4223e-16 13.2923 0 12.0873C-1.21115e-16 10.8823 0.976833 9.90545 2.18182 9.90545L2.28 9.90545C3.0189 9.88817 3.67215 9.42095 3.92727 8.72727C4.22438 8.05408 4.08182 7.26784 3.56727 6.74182L3.50182 6.67636C3.09212 6.26712 2.86192 5.7118 2.86192 5.13273C2.86192 4.55365 3.09212 3.99833 3.50182 3.58909C3.91106 3.1794 4.46638 2.94919 5.04545 2.94919C5.62453 2.94919 6.17985 3.1794 6.58909 3.58909L6.65455 3.65455C7.18057 4.16909 7.96681 4.31165 8.64 4.01455L8.72727 4.01455C9.38669 3.73193 9.81532 3.0847 9.81818 2.36727L9.81818 2.18182C9.81818 0.976833 10.795 2.4223e-16 12 0C13.205 0 14.1818 0.976833 14.1818 2.18182L14.1818 2.28C14.1847 2.99743 14.6133 3.64465 15.2727 3.92727C15.9459 4.22438 16.7322 4.08182 17.2582 3.56727L17.3236 3.50182C17.7329 3.09212 18.2882 2.86192 18.8673 2.86192C19.4463 2.86192 20.0017 3.09212 20.4109 3.50182C20.8206 3.91106 21.0508 4.46638 21.0508 5.04545C21.0508 5.62453 20.8206 6.17985 20.4109 6.58909L20.3455 6.65455C19.8309 7.18057 19.6884 7.96681 19.9855 8.64L19.9855 8.72727C20.2681 9.38669 20.9153 9.81532 21.6327 9.81818L21.8182 9.81818C23.0232 9.81818 24 10.795 24 12C24 13.205 23.0232 14.1818 21.8182 14.1818L21.72 14.1818C21.0026 14.1847 20.3553 14.6133 20.0727 15.2727Z" id="Path" fill="none" stroke="#214163" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
								  </g>
								</svg>
							</button>
							<button @click="showLink" v-click-outside="hideLink">
								<svg width="22px" height="25px">
								  <g id="share-2-(2)" transform="translate(1 1)">
								    <path d="M3.33333 6.66667C5.17428 6.66667 6.66667 5.17428 6.66667 3.33333C6.66667 1.49238 5.17428 0 3.33333 0C1.49238 0 0 1.49238 0 3.33333C0 5.17428 1.49238 6.66667 3.33333 6.66667Z" transform="translate(13.33203 0)" id="Oval" fill="none" stroke="#214163" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								    <path d="M3.33333 6.66667C5.17428 6.66667 6.66667 5.17428 6.66667 3.33333C6.66667 1.49238 5.17428 0 3.33333 0C1.49238 0 0 1.49238 0 3.33333C0 5.17428 1.49238 6.66667 3.33333 6.66667Z" transform="translate(0 7.777771)" id="Oval" fill="none" stroke="#214163" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								    <path d="M3.33333 6.66667C5.17428 6.66667 6.66667 5.17428 6.66667 3.33333C6.66667 1.49238 5.17428 0 3.33333 0C1.49238 0 0 1.49238 0 3.33333C0 5.17428 1.49238 6.66667 3.33333 6.66667Z" transform="translate(13.33203 15.55554)" id="Oval" fill="none" stroke="#214163" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								    <path d="M0 0L7.58889 4.42222" transform="translate(6.210938 12.78888)" id="Path" fill="none" stroke="#214163" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								    <path d="M7.57778 0L0 4.42222" transform="translate(6.210938 5.011108)" id="Path" fill="none" stroke="#214163" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								  </g>
								</svg>
								<div class="copyLink" :class="{'showLink':copyLink}" >
									<span>Copy Link:</span>http:commaful.com
								</div>
							</button>
						</div>
						<div class="collection-add">
							<p>MY COLLECTIONS</p>
							<a href="#" class="add-coll">
								<img src="../../assets/icon/plus-icon.svg" alt="icon" />
							</a>
						</div>

						<!-- collection box start -->
						<div class="collection-box-wrap">
							<div class="collection-single" 
								 v-for="collection in collections" 
								 :key="collection.id">
								<div class="collection-single-img">
									<img src="../../assets/images/mask02.jpg" :alt="collection.title" @click="collectionDetails(collection)">
									<!-- dropdown start -->
					                <base-dropdown class="collection-dropdown">
					                    <div class="dropdown-sm-icon vertical-toggle" slot="title">
											<img src="../../assets/icon/more-vertical.svg" alt="icon">
					                    </div>

					                    <template>
					                        <a href="#" class="dropdown-item">
					                           Add to All Pages
					                        </a>
					                        <a href="#" class="dropdown-item">
					                           Add to All Favorites
					                        </a>
					                        <a href="#" class="dropdown-item">
					                           Add to All Collections
					                        </a>
					                    </template>
					                </base-dropdown>
									<!-- dropdown end -->
								</div>
								<h3>{{collection.title}}</h3>
							</div>
							<!-- /. collection-single -->
						</div>
						<!-- collection box end-->
					</div>
					<!-- sidebar-collection end -->
				</div>
			</aside>
		</div>
		<!-- right sidebar end -->



	    <!-- collection setting modal start -->
		<modal v-if="showCollectionModal" class="collctionModal">
	    	<div slot="closeModal" @click="closeAllModal()">
	    		<i class="fas fa-times-circle"></i>
	    	</div>
		    <h3 slot="header">Collection Settings</h3>
		    <div slot="body">
		    	<ul class="modalInput">
		    		<li>
		    			<label>Name<span>:</span></label>
		    			<div class="inputName">
		    				<input type="text" placeholder="Nature Re">
		    			</div>
		    		</li>
		    		<li>
		    			<label>Privacy<span>:</span></label>
		    			<div class="selectedPrivacy">
		    				<select>
		    					<option>Public</option>
		    					<option>Private</option>
		    				</select>
		    			</div>
		    		</li>
		    		<li>
		    			<label>Tags<span>:</span></label>
		    			<div>
		    				<!-- <multiselect v-model="tagSelected" tag-placeholder="Add this as new tag" placeholder="Search or add a tag" label="name" track-by="code" :options="tags" :multiple="true"></multiselect> -->
						    <vue-tags-input class="collectionTag"
						      v-model="tagSelected"
						      :tags="tags"
						      @tags-changed="newTags => tags = newTags"
						      add-on-key="['13', ':']"
						      @delete-on-backspace="true"
						    />
		    			</div>
		    		</li>
		    	</ul>
		    </div>
		    <div slot="footer">	    	
	          <button class="modal-default-button" @click="saveCollection">SAVE</button>
		    </div>
		</modal>
	    <!-- collection setting modal end -->
	</div>
</template>

<script>
import VueTagsInput from '@johmun/vue-tags-input';
import { EventBus } from '../../main';

export default {
  	components: { VueTagsInput },
	name:'sidebar-right',
	data(){
		return{
			expandSearchBar:false,
			//modal data
			showPageModal:false,
			showCollectionModal:false,
		    tagSelected: '',
		    tags: [],
        	showCollBtn:'',
        	//show-sidebar
        	showbar:false,
        	copyLink:false,
        	//search box
        	sidebarSarch:'',
	        collections: [
		      {
		        id: 1,
		        title: 'Scary Photos',
		        images: '../assets/images/mask1.jpeg',
		        shareLink: 'www.sharelink.com',
		      },
		      {
		        id: 2,
		        title: 'Trees',
		        images: '../assets/images/mask2.jpeg',
		        shareLink: 'www.sharelink.com',
		      },
		      {
		        id: 3,
		        title: 'Scary Photos',
		        images: '../assets/images/mask3.jpeg',
		        shareLink: 'www.sharelink.com',
		      },
		      {
		        id: 4,
		        title: 'Trees',
		        images: '../assets/images/mask4.jpeg',
		        shareLink: 'www.sharelink.com',
		      }
		    ],
		}
	},

	methods:{
	    addPageModal() {
	      EventBus.$emit('showModals', true);
	    },
		showSidebar()  {
			this.showbar=!this.showbar;
			this.$emit("showbar", this.showbar);
		},

		showLink()  {
			this.copyLink=!this.copyLink;
			this.$emit("copyLink", this.copyLink);
		},
		hideLink()  {
			this.copyLink = false;
			this.$emit("copyLink", this.copyLink);
		},

		backToColl()  {
			this.showCollBtn = '';
		},

		collectionDetails(data){
			this.showCollBtn=data;
		},

		showCollModal() {
			this.showCollectionModal=true
	      	EventBus.$emit('showCollectionModal', true);
		},

		saveCollection() {
			this.showCollectionModal=false
	      	EventBus.$emit('showCollectionModal', false);
		},

		closeAllModal(){
			this.showCollectionModal=false
	      	EventBus.$emit('showCollectionModal', false);
		},		
		mblSearchClk(){
			this.expandSearchBar=true;
		},
		closeExpandSearch(){
			this.expandSearchBar=false;
		}
	},
	mounted() {
      EventBus.$on('showBtm', data => {
      	if(this.showbar==true && data==true){
      		this.showbar=false
      	} else {
        	this.showbar=data;
      	}
      });
	}
}

</script>


<style>
	@import '../../assets/css/sidebar-right.css';
	/*-- dragable area css --*/
	.collectionTag .ti-input {
	    border: none !important;
	    border-bottom: solid 1px rgba(33, 65, 99, .4) !important;
	}
	.modalInput .selectedPrivacy select {
	    background: transparent;
	}
	.collectionTag .ti-tag{
		background: #214163 !important;
	}
	.collectionTag .ti-tag,
	.collectionTag .ti-tag span,
	.collectionTag input::-webkit-input-placeholder,
	.collectionTag input:-ms-input-placeholder,
	.collectionTag input::placeholder {
	    color: #214163 !important;
	    font-family: Lato !important;
	    font-size: 18px !important;
	    font-weight: 400 !important;
	    line-height: 22px !important;
	    letter-spacing: 0.45px !important;
	}
	.collectionTag .ti-new-tag-input-wrapper{
		padding-top: 0px;
		padding-bottom: 0px;
	}
	.collectionTag .ti-new-tag-input-wrapper input{
		    min-height: 24px;
	}

	@media only screen and (max-width: 576px){
		.collectionTag .ti-tag,
		.collectionTag .ti-tag span,
		.collectionTag input::-webkit-input-placeholder,
		.collectionTag input:-ms-input-placeholder,
		.collectionTag input::placeholder {
		    font-size: 14px !important;
		}
	}
</style>